import React, { useState } from 'react'
import './style.scss'
import { CircleXIcon, SearchIcon } from 'assets/icons/components'

const SearchBar = ({ currentSearchCrmCaseId, setCurrentSearchCrmCaseId, submitSearch, placeholderMessage }) => {
  const [isFocused, setIsFocused] = useState(false)

  const handleSearch = () => {
    if (submitSearch) {
      submitSearch(currentSearchCrmCaseId)
    }
  }

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  const handleInputChange = e => {
    const value = e.target.value
    // Only allow numeric input (empty string or numbers)
    if (value === '' || /^[0-9]+$/.test(value)) {
      setCurrentSearchCrmCaseId(value)
    }
  }

  return (
    <div className={`search-bar-container ${isFocused ? ' search-bar-focused' : ''}`}>
      <div className="search-input-container">
        <SearchIcon style={{ marginRight: '10px', marginLeft: '10px' }} />
        <input type="text" className="search-input" placeholder={placeholderMessage} value={currentSearchCrmCaseId} onChange={handleInputChange} onKeyPress={handleKeyPress} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} />
        {currentSearchCrmCaseId && (
          <div className="clear-search">
            <CircleXIcon
              onClick={() => {
                setCurrentSearchCrmCaseId('')
                submitSearch('')
              }}
            />
          </div>
        )}
      </div>

      <button className="custom-round-btn btn btn-info button-size" onClick={handleSearch}>
        Search
      </button>
    </div>
  )
}

export default SearchBar
